export default function getResource(label) {
    const resources = {
        sectionTitle: 'Récompenses exclusives Rouge',
        rougeBadge: 'ROUGE'
    };
    return resources[label];
}
